import * as Yup from 'yup'
import * as service from '../../../services'
import { schema } from '../../../utils/schemaValidation'
import { getInitialState } from '../../../utils/formikUpdate'

export const datasetFormik = async () => {
  const familyAll = await service.getFamilyAll()

  const ITEMS_SPECIE_FORMIK = [
    { x: 12, name: 'specie_', initvalue: '', label: 'Nombre Científico' },
    { x: 12, name: 'clasificador_', initvalue: '', label: 'Clasificador' },
    {
      x: 12,
      name: 'family_',
      initvalue: '',
      label: 'Familia',
      options: familyAll,
    },
    {
      x: 12,
      name: 'estado_validacion',
      initvalue: 'verificado',
      label: 'Estado de validación',
      options: { verificado: 'Verificado', pendiente: 'Pendiente' },
    },
  ]

  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_SPECIE_FORMIK)

  const FORM_VALIDATION = Yup.object().shape({
    ...schema.SPECIE,
    ...schema.CLASSIFIER,
    ...schema.FAMILY,
  })

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_SPECIE_FORMIK,
    FORM_VALIDATION,
  }
}
